import { NavLink } from "react-router-dom";
import logoBlue from "../assets/images/logo_blue.svg";
import ThemeToggle from "./ThemeToggle";

export default function SiteNavbar() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-gray-200 bg-white/80 dark:bg-gray-900/80 dark:border-gray-700 backdrop-blur-lg">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        {/* Brand */}
        <NavLink to="/" className="flex items-center gap-2" aria-label="ItsAcademic home">
          <img src={logoBlue} alt="ItsAcademic logo" className="h-7 w-auto" />
        </NavLink>

        {/* Links */}
        <nav className="hidden items-center gap-6 text-sm font-medium md:flex">
          <NavLink
            to="/students"
            className={({ isActive }) =>
              [
                "transition-colors hover:text-primary",
                isActive
                  ? "text-primary"
                  : "text-gray-700 dark:text-gray-200",
              ].join(" ")
            }
          >
            Students
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              [
                "transition-colors hover:text-primary",
                isActive
                  ? "text-primary"
                  : "text-gray-700 dark:text-gray-200",
              ].join(" ")
            }
          >
            About
          </NavLink>
          <NavLink
            to="/pricing"
            className={({ isActive }) =>
              [
                "transition-colors hover:text-primary",
                isActive
                  ? "text-primary"
                  : "text-gray-700 dark:text-gray-200",
              ].join(" ")
            }
          >
            Pricing
          </NavLink>
        </nav>

        <div className="flex items-center gap-4">
          <ThemeToggle />
          <NavLink
            to="/app"
            className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white shadow transition-colors hover:bg-primary-dark focus:outline-hidden focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-gray-100 dark:focus:ring-offset-gray-900"
          >
            Launch App
          </NavLink>
        </div>
      </div>
    </header>
  );
}
